import { createReducer, on } from '@ngrx/store';

import { SoilAnalysisState } from '../models/soil-analysis.models';
import * as SoilAnalysisActions from '../store/soil-analysis.actions';

export const initialState: SoilAnalysisState = {};

export const soilAnalysisReducer = createReducer<SoilAnalysisState>(
  initialState,
  on(SoilAnalysisActions.loadDefaultSoilAnalysesSuccess, (state, { defaultSoilAnalyses }) => ({
    ...state,
    defaultSoilAnalyses,
  })),
);
